var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white p-6" },
    [
      _c("div", { staticClass: "flex flex-col" }, [
        _c(
          "div",
          { staticClass: "flex sm:flex-row flex-col" },
          [
            _c("div", { staticClass: "left-side-bar" }, [
              _c(
                "div",
                {
                  staticClass:
                    "space-y-2 bg-default-light-grey left-side-bar-content",
                },
                _vm._l(_vm.sidebarTabs, function (tab, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      class: [
                        "w-full text-left px-4 py-2 rounded-lg focus:outline-none left-bar-button text-sm sm:text-lg font-normal",
                        _vm.activeTab === tab.id
                          ? "bg-yellow-100 font-medium text-black"
                          : "hover:bg-gray-50 text-gray-400",
                      ],
                      on: {
                        click: function ($event) {
                          _vm.activeTab = tab.id
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(tab.name) + " ")]
                  )
                }),
                0
              ),
            ]),
            _vm.activeTab === "basic"
              ? _c("BasicInformation", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "required"
              ? _c("RequiredServices", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "emergency"
              ? _c("EmergencyContact", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "access"
              ? _c("AccessInformation", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "language"
              ? _c("LanguageCommunication", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "health"
              ? _c("HealthInformation", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "assessment"
              ? _c("FunctionalAssessment", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "considerations"
              ? _c("PersonalConsiderations", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "network"
              ? _c("SupportNetwork", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "goals"
              ? _c("CareGoals", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "notes"
              ? _c("AdditionalNotes", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.showEditModal
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.showEditModal,
              activeTab: _vm.activeTab,
              initialData: _vm.formattedClientData,
              companyId: _vm.company.id,
              currentUser: _vm.currentUser,
              currentEditTab: _vm.currentEditTab,
              isEdit: true,
            },
            on: {
              closeDialog: _vm.hanldeCancel,
              close: _vm.closeEditModal,
              "save-draft": _vm.handleSaveDraft,
              "update:formData": _vm.updateFormData,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }